import { Observable } from 'rxjs'
import { ParentOfMasterTypeModel } from '../models/master-type.model'
import { BaseService } from '../services/base.service'

export abstract class MasterTypeRepository extends BaseService {
	abstract GetByTypeParent(params: { id: number }): Observable<ParentOfMasterTypeModel[]>
}
